export const OFFER_STATUS = 'OFFER'
export const NEGOTIATIONS_STATUS = 'NEGOTIATIONS'
export const BUYER_CONDITIONS_STATUS = 'BUYER_CONDITIONS'
export const SELLER_RESPONSE_STATUS = 'SELLER_RESPONSE'
export const ACCEPTED_STATUS = 'ACCEPTED'
export const BUYER_DECLINED_STATUS = 'BUYER_DECLINED'
export const SELLER_DECLINED_STATUS = 'SELLER_DECLINED'
export const EXPIRED_STATUS = 'EXPIRED'
export const DRAFT_STATUS = 'DRAFT'
export const ARCHIVED_STATUS = 'ARCHIVED'
export const OFFER_RECOGNITION_STATUS = 'OFFER_RECOGNITION'
export const OFFER_RECOGNITION_ERROR_STATUS = 'OFFER_RECOGNITION_ERROR'
export const DRAFT_RECOGNITION_STATUS = 'DRAFT_RECOGNITION'
export const DRAFT_RECOGNITION_ERROR_STATUS = 'DRAFT_RECOGNITION_ERROR'
export const ACCEPTED_RECOGNITION_STATUS = 'ACCEPTED_RECOGNITION'
export const ACCEPTED_RECOGNITION_ERROR_STATUS = 'ACCEPTED_RECOGNITION_ERROR'
export const EXPIRED_RECOGNITION_STATUS = 'EXPIRED_RECOGNITION'
export const EXPIRED_RECOGNITION_ERROR_STATUS = 'EXPIRED_RECOGNITION_ERROR'

export enum WineOfferStatusCode {
  Offer = 'OFFER',
  Negotiations = 'NEGOTIATIONS',
  BuyerConditions = 'BUYER_CONDITIONS',
  SellerResponse = 'SELLER_RESPONSE',
  Accepted = 'ACCEPTED',
  BuyerDeclined = 'BUYER_DECLINED',
  SellerDeclined = 'SELLER_DECLINED',
  Expired = 'EXPIRED',
  Draft = 'DRAFT',
  Archived = 'ARCHIVED',
  OfferRecognition = 'OFFER_RECOGNITION',
  OfferRecognitionError = 'OFFER_RECOGNITION_ERROR',
  DraftRecognition = 'DRAFT_RECOGNITION',
  DraftRecognitionError = 'DRAFT_RECOGNITION_ERROR',
  AcceptedRecognition = 'ACCEPTED_RECOGNITION',
  AcceptedRecognitionError = 'ACCEPTED_RECOGNITION_ERROR',
  ExpiredRecognition = 'EXPIRED_RECOGNITION',
  ExpiredRecognitionError = 'EXPIRED_RECOGNITION_ERROR',
}

export const wineOfferStatus = {
  [OFFER_STATUS]: 'OFFER',
  [NEGOTIATIONS_STATUS]: 'NEGOTIATIONS',
  [BUYER_CONDITIONS_STATUS]: 'BUYER_CONDITIONS',
  [SELLER_RESPONSE_STATUS]: 'SELLER_RESPONSE',
  [ACCEPTED_STATUS]: 'ACCEPTED',
  [BUYER_DECLINED_STATUS]: 'BUYER_DECLINED',
  [SELLER_DECLINED_STATUS]: 'SELLER_DECLINED',
  [EXPIRED_STATUS]: 'EXPIRED',
  [DRAFT_STATUS]: 'DRAFT',
  [ARCHIVED_STATUS]: 'ARCHIVED',
  [OFFER_RECOGNITION_STATUS]: 'OFFER_RECOGNITION',
  [OFFER_RECOGNITION_ERROR_STATUS]: 'OFFER_RECOGNITION_ERROR',
  [DRAFT_RECOGNITION_STATUS]: 'DRAFT_RECOGNITION',
  [DRAFT_RECOGNITION_ERROR_STATUS]: 'DRAFT_RECOGNITION_ERROR',
  [ACCEPTED_RECOGNITION_STATUS]: 'ACCEPTED_RECOGNITION',
  [ACCEPTED_RECOGNITION_ERROR_STATUS]: 'ACCEPTED_RECOGNITION_ERROR',
  [EXPIRED_RECOGNITION_STATUS]: EXPIRED_RECOGNITION_STATUS,
  [EXPIRED_RECOGNITION_ERROR_STATUS]: EXPIRED_RECOGNITION_ERROR_STATUS,
}

export const wineOfferStatusId = {
  [OFFER_STATUS]: 1,
  [NEGOTIATIONS_STATUS]: 2,
  [BUYER_CONDITIONS_STATUS]: 3,
  [SELLER_RESPONSE_STATUS]: 4,
  [ACCEPTED_STATUS]: 5,
  [BUYER_DECLINED_STATUS]: 6,
  [SELLER_DECLINED_STATUS]: 7,
  [EXPIRED_STATUS]: 8,
  [DRAFT_STATUS]: 9,
  [ARCHIVED_STATUS]: 10,
  [DRAFT_RECOGNITION_STATUS]: 11,
  [DRAFT_RECOGNITION_ERROR_STATUS]: 12,
  [OFFER_RECOGNITION_STATUS]: 13,
  [OFFER_RECOGNITION_ERROR_STATUS]: 14,
  [ACCEPTED_RECOGNITION_STATUS]: 15,
  [ACCEPTED_RECOGNITION_ERROR_STATUS]: 16,
  [EXPIRED_RECOGNITION_STATUS]: 17,
  [EXPIRED_RECOGNITION_ERROR_STATUS]: 18,
}

export const PUBLIC_TYPE = 'PUBLIC'
export const COMPANY_TYPE = 'COMPANY'
export const PERSONAL_TYPE = 'PERSONAL'
export const DEAL_TYPE = 'DEAL'

export const PUBLISHED_OFFER_STATUS = 'OFFER'
export const DRAFT_OFFER_STATUS = 'DRAFT'

export const PRODUCER_CATEGORY_ID = 1
export const WHOLESELLER_CATEGORY_ID = 3
export const RESTAURANT_CATEGORY_ID = 5
export const RETAILER_CATEGORY_ID = 6

export enum WineOfferTypeId {
  Public = 1,
  Personal = 2,
  Company = 3,
  Deal = 4,
}

export enum WineOfferTypeCode {
  Public = 'PUBLIC',
  Personal = 'PERSONAL',
  Company = 'COMPANY',
  Deal = 'DEAL',
}

export const isRecognitionRelatedStatus = (code: string) =>
  [
    OFFER_RECOGNITION_STATUS,
    OFFER_RECOGNITION_ERROR_STATUS,
    DRAFT_RECOGNITION_STATUS,
    DRAFT_RECOGNITION_ERROR_STATUS,
    ACCEPTED_RECOGNITION_STATUS,
    ACCEPTED_RECOGNITION_ERROR_STATUS,
    EXPIRED_RECOGNITION_STATUS,
    EXPIRED_RECOGNITION_ERROR_STATUS,
  ].includes(code)
